import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0edbd3cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "operation-feedback-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeedbackContent = _resolveComponent("FeedbackContent")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    "wrap-class-name": "operation-feedback-wrap",
    visible: _ctx.visible,
    title: _ctx.dialog?.title,
    footer: null,
    closable: false,
    "mask-closable": false,
    keyboard: false,
    "focus-trigger-after-close": false,
    width: 480,
    centered: "",
    "after-close": _ctx.finish
  }, {
    default: _withCtx(() => [
      (_ctx.dialog)
        ? (_openBlock(), _createBlock(_component_FeedbackContent, {
            key: 0,
            content: _ctx.dialog.content
          }, null, 8, ["content"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.confirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.dialog?.okText || '我知道了'), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title", "after-close"]))
}